<template>
  <div class="unit-hero-container">
    <div class="flex-column">
      <img
        src="@shared/assets/img/adoption/sensor.png"
        alt="SmartAc.com Hardware"
        class="sensor-img"
      >
      <div class="sub-header">
        SMARTAC.COM UNITS
      </div>
    </div>
    <div class="flex-column">
      <div class="sub-header">
        LAST 7 DAYS
      </div>
      <div
        v-if="loading"
        class="body-header"
      >
        <img
          src="@shared/assets/img/general/loading-white.svg"
          alt="Loading"
          class="loading-img"
        >
      </div>
      <div
        v-else
        class="body-header"
      >
        {{ getNumberLocale(lastSevenDays) }}
        <img
          v-if="lastSevenChange === 'up'"
          src="@shared/assets/img/adoption/up.png"
          alt="Change Indicator"
          class="change-icon"
        >
        <img
          v-else-if="lastSevenChange === 'down'"
          src="@shared/assets/img/adoption/down.png"
          alt="Change Indicator"
          class="change-icon"
        >
      </div>
    </div>
    <div class="flex-column">
      <div class="sub-header">
        LAST 30 DAYS
      </div>
      <div
        v-if="loading"
        class="body-header"
      >
        <img
          src="@shared/assets/img/general/loading-white.svg"
          alt="Loading"
          class="loading-img"
        >
      </div>
      <div
        v-else
        class="body-header"
      >
        {{ getNumberLocale(lastThirtyDays) }}
        <img
          v-if="lastThirtyChange === 'up'"
          src="@shared/assets/img/adoption/up.png"
          alt="Change Indicator"
          class="change-icon"
        >
        <img
          v-else-if="lastThirtyChange === 'down'"
          src="@shared/assets/img/adoption/down.png"
          alt="Change Indicator"
          class="change-icon"
        >
      </div>
    </div>
    <div class="flex-column">
      <div class="sub-header">
        LAST 12 MONTHS
      </div>
      <div
        v-if="loading"
        class="body-header"
      >
        <img
          src="@shared/assets/img/general/loading-white.svg"
          alt="Loading"
          class="loading-img"
        >
      </div>
      <div
        v-else
        class="body-header"
      >
        {{ getNumberLocale(lastTwelveMonths) }}
        <img
          v-if="lastTwelveChange === 'up'"
          src="@shared/assets/img/adoption/up.png"
          alt="Change Indicator"
          class="change-icon"
        >
        <img
          v-else-if="lastTwelveChange === 'down'"
          src="@shared/assets/img/adoption/down.png"
          alt="Change Indicator"
          class="change-icon"
        >
      </div>
    </div>
    <div class="custom-range-container">
      <div>
        <div class="date-filter-container">
          <Datepicker
            v-model="dateRange"
            mode="range"
            :max-date="new Date()"
          >
            <template #default>
              <div class="sub-header-button">
                <span v-if="customRangeStat === null">
                  CUSTOM RANGE
                </span>
                <span v-else>
                  {{ customRangeHeader }}
                </span>
                <img
                  v-if="customRangeStat === null"
                  src="@shared/assets/img/general/chevron-white-down.png"
                  alt="Select"
                  class="button-icon"
                >
                <div
                  v-else
                  class="clear-container"
                >
                  <div class="clear-tooltip">
                    Clear Dates
                  </div>
                  <button
                    class="clear-btn"
                    @click="clearRangeFilter"
                  >
                    <img
                      class="button-icon"
                      src="@shared/assets/img/general/x-white.png"
                      alt="Clear"
                    >
                  </button>
                </div>
              </div>
            </template>
          </Datepicker>
        </div>
        <div
          v-if="loading || loadingCustom"
          class="body-header"
        >
          <img
            src="@shared/assets/img/general/loading-white.svg"
            alt="Loading"
            class="loading-img"
          >
        </div>
        <div
          v-else-if="customRangeStat !== null"
          class="body-header"
        >
          {{ getNumberLocale(customRangeStat) }}
        </div>
        <div
          v-else
          class="body-header"
        >
          {{ getNumberLocale(lastNinetyDays) }}
          <img
            v-if="lastNinetyChange === 'up'"
            src="@shared/assets/img/adoption/up.png"
            alt="Change Indicator"
            class="change-icon"
          >
          <img
            v-else-if="lastNinetyChange === 'down'"
            src="@shared/assets/img/adoption/down.png"
            alt="Change Indicator"
            class="change-icon"
          >
        </div>
      </div>
      <SACTooltipItem
        v-if="customRangeStat === null"
        light
        label=""
        tip="Custom range is default to last 90 days"
      />
    </div>
    <div class="flex-column">
      <div class="sub-header">
        ALL TIME
      </div>
      <div
        v-if="loading"
        class="body-header"
      >
        <img
          src="@shared/assets/img/general/loading-white.svg"
          alt="Loading"
          class="loading-img"
        >
      </div>
      <div
        v-else
        class="body-header"
      >
        {{ getNumberLocale(allTime) }}
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import Datepicker from 'v-calendar/lib/components/date-picker.umd';

import adoptionMixin from '@shared/mixins/adoptionMixin';
import formatterMixin from '@shared/mixins/formatterMixin';
import unitPreferencesMixin from '@shared/mixins/unitPreferencesMixin';

import apiClient from '@shared/lib/general/apiClient';
import SACTooltipItem from '@shared/components/sac/SACTooltip.vue';
import adminMixin from '@shared/mixins/adminMixin';

export default {
  name: 'UnitHero',
  components: {
    SACTooltipItem,
    Datepicker,
  },
  mixins: [adoptionMixin, adminMixin, formatterMixin, unitPreferencesMixin],
  data() {
    return {
      lastSevenDays: 0,
      lastSevenChange: null,
      lastThirtyDays: 0,
      lastThirtyChange: null,
      lastTwelveMonths: 0,
      lastTwelveChange: null,
      lastNinetyDays: 0,
      lastNinetyChange: null,
      customRangeStat: null,
      customRange: {
        start: null,
        end: null,
      },
      allTime: 0,
      loading: true,
      loadingCustom: false,
    };
  },
  computed: {
    dateRange: {
      get() {
        return this.customRange;
      },
      set(dateRange) {
        if (dateRange && dateRange.start && dateRange.end) {
          const {
            start,
            end,
          } = dateRange;
          this.customRange = dateRange;
          this.getUnitCountByRange(start, end);
        }
      },
    },
    customRangeHeader() {
      const {
        start,
        end,
      } = this.customRange;

      const {
        dateFormat,
      } = this;

      if (start && end) {
        let startFormat = dateFormat === 'M/D' ? 'MMM D' : 'D MMM';
        if (!moment(start).isSame(end, 'year')) {
          startFormat = dateFormat === 'M/D' ? 'MMM D \'YY' : 'D MMM \'YY';
        }
        const endFormat = dateFormat === 'M/D' ? 'MMM D \'YY' : 'D MMM \'YY';
        const rangeStart = moment(start).format(startFormat);
        const rangeEnd = moment(end).format(endFormat);
        return `${rangeStart} - ${rangeEnd}`;
      }
      return null;
    },
  },
  watch: {
    selectedCorpId() {
      this.getUnitOverview();
      if (this.customRange && this.customRange.start && this.customRange.end) {
        const {
          start,
          end,
        } = this.customRange;
        this.getUnitCountByRange(start, end);
      }
    },
  },
  mounted() {
    if (this.selectedCorpId) {
      this.getUnitOverview();
    }
  },
  methods: {
    async getUnitOverview() {
      this.loading = true;
      try {
        const { data } = await apiClient({
          method: 'GET',
          url: `/adoption/stat/units/corp/${this.selectedCorpId}/overview`,
        });
        const {
          lastSevenDays,
          prevSevenDays,
          lastThirtyDays,
          prevThirtyDays,
          lastTwelveMonths,
          prevTwelveMonths,
          lastNinetyDays,
          prevNinetyDays,
          allTime,
        } = data;
        this.lastSevenDays = lastSevenDays ?? 0;
        this.lastSevenChange = this.calculateChange(lastSevenDays, prevSevenDays);
        this.lastThirtyDays = lastThirtyDays ?? 0;
        this.lastThirtyChange = this.calculateChange(lastThirtyDays, prevThirtyDays);
        this.lastTwelveMonths = lastTwelveMonths ?? 0;
        this.lastTwelveChange = this.calculateChange(lastTwelveMonths, prevTwelveMonths);
        this.lastNinetyDays = lastNinetyDays ?? 0;
        this.lastNinetyChange = this.calculateChange(lastNinetyDays, prevNinetyDays);
        this.allTime = allTime ?? 0;
      } catch (err) {
        console.error(err);
      }
      this.loading = false;
    },
    async getUnitCountByRange(start, end) {
      this.loadingCustom = true;
      try {
        const startQuery = moment(start).format('YYYY-MM-DD');
        const endQuery = moment(end).format('YYYY-MM-DD');
        const { data } = await apiClient({
          method: 'GET',
          url: `/adoption/stat/units/corp/${this.selectedCorpId}/start/${startQuery}/end/${endQuery}`,
        });
        const {
          count,
        } = data;
        this.customRangeStat = count;
      } catch (err) {
        console.error(err);
      }
      this.loadingCustom = false;
    },
    calculateChange(last, prev) {
      if (last > prev) {
        return 'up';
      }
      if (last < prev) {
        return 'down';
      }
      return null;
    },
    clearRangeFilter() {
      this.customRangeStat = null;
      this.customRange = {
        start: null,
        end: null,
      };
    },
  },
};
</script>

<style lang="scss" scoped>

.unit-hero-container {
  background-color: $N95;
  padding: 24px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .sensor-img {
    width: 22px;
    object-fit: contain;
    margin-bottom: 8px;
  }

  .sub-header {
    font-size: 0.875rem;
    color: $WHITE;
    font-weight: 700;
    text-align: right;
  }

  .sub-header-button {
    font-size: 0.875rem;
    color: $WHITE;
    font-weight: 700;
    display: flex;
    align-items: flex-end;
    text-decoration: underline;
    text-align: right;

    .button-icon {
      width: 20px;
      object-fit: contain;
    }
  }

  .body-header {
    line-height: 1.2;
    color: $WHITE;
    font-size: 2rem;
    font-weight: 500;
    text-align: right;
  }

  .change-icon {
    width: 10px;
    height: 6px;
    object-fit: contain;
  }

  .loading-img {
    width: 35px;
    height: 35px;
  }

  .clear-container {
    position: relative;

    &:hover {
      .clear-tooltip {
        opacity: 1;
      }
    }

    .clear-btn {
      display: flex;
    }

    .clear-tooltip {
      position: absolute;
      top: -20px;
      left: -26px;
      opacity: 0;
      background-color: $WHITE;
      color: $N100;
      font-size: 0.625rem;
      padding: 2px 4px;
      border-radius: 4px;
      white-space: nowrap;

      &:hover {
        opacity: 1;
      }
    }
  }

  .custom-range-container {
    display: flex;
  }
}
</style>
